const CREATE = 'CREATE'
const VIEW = 'VIEW'
const RESOLVE = 'RESOLVE'
const DOWNLOAD = 'DOWNLOAD'

export const CameraEventUserAccessActions = {
    CREATE,
    VIEW,
    RESOLVE,
    DOWNLOAD
}
